var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"group relative p-2 cursor-pointer rounded-lg hover:bg-gray-100 border border-transparent font-medium",class:[
    _vm.selected && 'text-blue-600 !bg-blue-50 hover:!border-transparent-200 font-bold',
 ]},[_c('span',[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }